import {
  Box,
  Button,
  Container, Drawer, Grid, IconButton, Tab, Tabs, Tooltip, Typography
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import EnhancedTable, { HeadCell } from '../../common/components/EnhancedTable';
import ItemsDrawer from '../../common/components/ItemsDrawer';
import { customtheme } from '../../app/theme/theme';
import { getProcessEmitPurchaseOrderByUser } from '../../app/services/purchase-order/get-emit-purchase-order-module.api';
import { mapperToPurchaseOrder } from '../../app/mappers/purchase-order/purchase-order.mapper';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: customtheme.gray[200],
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  topBar: {
    backgroundColor: customtheme.gray[200],
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
  },  
  topBarContent: {   
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  topBarButtons: {
    '& > *': {
      marginLeft: theme.spacing(1),
    },
  },
  content: {
    // position: 'relative',
    // flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: '50%',
    backgroundColor: customtheme.white,
  },
  card: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tableSection: {
    padding: theme.spacing(4),
    flex: 1,
    display: 'flex',
  },
  tableSectionContainer: {
    padding: 0, 
    flex: 1,
    display: 'flex', 
    flexDirection: 'column',
    maxWidth: '100%',
  },
  appbar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    background: customtheme.white,
    color: customtheme.black,
    padding: theme.spacing(2),
    margin: 1,
  },  
  scrollableTabs: {
    overflowX: 'auto',
  }, drawer: {
    width: 400,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2), 
    height: '100%',
  },
  drawerFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-input': {
      color: customtheme.black,
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: customtheme.blue[500],
    },
  },
  searchIcon: {
    marginRight: theme.spacing(1),
    color: customtheme.blue[500],
  },
  backBackgroundColor: {
    background: customtheme.gray[200],
    color: customtheme.blue[500],
    '&:hover': {
      background: customtheme.blue[50],
      color: customtheme.blue[500],
    },
  },
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabRoot: {
    minWidth: 0,
    paddingLeft: 8,
    paddingRight: 8,
    },
}));
interface TabPanelProps {
  value: number;
  index: number;
  children?: React.ReactNode;
}
const TabPanel = ({ value, index, children }: TabPanelProps) => (
  <div role="tabpanel" hidden={value !== index} style={{ flex: 1 }}>
    {value === index && <Box>{children}</Box>}
  </div>
);

const PurchaseOrderConsult = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const handleTabChange = (_: unknown, newValue: number) => setTab(newValue);

  const windowHeight = window.innerHeight;
  const headerHeight = 500; // Altura do cabeçalho em pixels
  const footerHeight = 48; // Altura do rodapé em pixels
  const itemHeight = 80; // Altura média de cada item em pixels
  const availableHeight = windowHeight - headerHeight - footerHeight;
  const itemsPerPage = Math.floor((availableHeight) / itemHeight)

  const [selectedData, setSelectedData] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<string>('numero');
  const [selected, setSelected] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage > 5 ? itemsPerPage : 5);
  const [fields, setFields] = useState<any[]>([])
  const [parcelas, setParcelas] = useState<any[]>([])
  const [generalFields, setGeneralFields] = useState<any[]>([])
  const [isDrawerOpen, setIsDrawerOpen] = useState({open: false, btnTitle: 'Voltar', btnType: 'back'});

  const fieldsItems = ['coditem', 'desitem', 'codder', 'desder',
    'qtd', 'valorunitario', 'valortotal', 'datprv', 
    'unidademedida', 'codccu', 'desccu', 'codFinanceira', 'desFinanceira', 
    'codContabil', 'desContabil'
  ];
  const fieldsParcelas = ['seqpar', 'vlrpar', 'vctpar' ];

  const handleCloseDrawer = () => {
    setSelected([])
    setFields([]);
    setParcelas([]);
    setIsDrawerOpen({open: false, btnTitle: 'Salvar', btnType: 'save'});
  };

   const { isFetching, refetch } = useQuery(['purchaseOrderEmitConsult'], async () => {
       const token = localStorage.getItem('token')
       if(token){
         const res = await getProcessEmitPurchaseOrderByUser(token, {
           take: rowsPerPage,
           skip: page*rowsPerPage,
         })
         if(res){
           setSelectedData(res.results)
           setCount(res.total)
         }
       }
       return []
     }, {
       refetchOnWindowFocus: false,
     })

  useEffect(() => {
    refetch();
  }, [page, refetch]);
  
  const headCells: HeadCell[] = [
    { id: 'sigemp', numeric: false, disablePadding: true, label: 'Nome Empresa' },
    { id: 'nomfor', numeric: false, disablePadding: true, label: 'Nome Fornecedor' },
    { id: 'valortotal', numeric: false, disablePadding: true, label: 'Valor' },
    { id: 'datemi', numeric: false, disablePadding: true, label: 'Data Emissão' },
    { id: 'numoc', numeric: true, disablePadding: false, label: 'Num OC' },
    { id: 'actions', numeric: true, disablePadding: false, label: 'Ações' },
  ];

  const createData = (props:any) => {
    const { id, sigemp, nomfor, ItemEmissaOrdemCompra, datemi, numoc} = props
    let valortotal = 0;
    ItemEmissaOrdemCompra.forEach((item:any) => {
      valortotal += item.valortotal
    })

    return { id, sigemp, nomfor, valortotal, datemi, numoc, ...props };
  }

  const handleInfo = (id:any) => {
    const item = selectedData.filter((data:any) => data.id === id )
    if(item.length > 0){
      setGeneralFields(mapperToPurchaseOrder(item[0]));
      setFields(item[0].ItemEmissaOrdemCompra)
      setParcelas(item[0].parcelas || [])
      setIsDrawerOpen({open: true, btnTitle: 'Info', btnType: 'voltar'});
    }
  }

  const handleCheckItems = () => {
    const itemSelected = selectedData.filter((data:any) => data.id === selected[0])
    if(itemSelected){
      const items = Object.entries(itemSelected[0]).find(([key, val]:any) => key === 'item' && val.length > 0)
      if(items && items[1] !== null)
        return true
      else
        return false
    }
    return false
  }

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
      </div>
      <div className={classes.content}>
      </div>
      <div className={classes.tableSection}>
      <Container className={classes.tableSectionContainer}>
          <EnhancedTable 
            title=''
            rowsPerPageOptions={[]}
            isClickable={true}
            data={selectedData?.map((data:any) => createData(data) )}
            count={count}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            headCells={headCells}
            isLoading={isFetching}
            selected={selected}
            setSelected={setSelected}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            buttonsSelected={[ 
              (selected.length === 1 && handleCheckItems()) && 
                <Tooltip
                  title="Info"
                  onClick={() => handleInfo(`${selected[0]}`)}
                  key='info'
                >
                <IconButton aria-label="info">
                  <ErrorIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
            ]}
            buttonsActions={['itens']}
            handleInfo={handleInfo}
          />
        </Container>
      </div>
      <Drawer
        anchor="right"
        open={isDrawerOpen.open}
        onClose={handleCloseDrawer}
        classes={{ paper: classes.drawer }}
      >
        <div className={classes.drawerHeader}>
          <Typography variant="h6">Itens</Typography>
        </div>
        <div className={classes.drawerContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={tab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                className={classes.tabsBar}
              >
                <Tab label="Produtos"classes={{ root: classes.tabRoot }} />
                <Tab label="Serviços"classes={{ root: classes.tabRoot }} />
                <Tab label="Parcelas" classes={{ root: classes.tabRoot }}/>
                <Tab label="Anexos" classes={{ root: classes.tabRoot }}/>
              </Tabs>

              <TabPanel value={tab} index={0}>
                {
                  fields.filter(((item) => item.tipo === 'produto')).length === 0 && 
                  <Box mt={3}>
                    <Typography>Nenhum produto criado</Typography>
                  </Box>
                }
                <ItemsDrawer
                  fields={fields.filter(((item) => item.tipo === 'produto'))} 
                  fieldsItems={fieldsItems}
                  keyTitle='descricao'
                  keySubTitle=''
                  labelsFields={
                    [
                      {
                        key: 'coditem',
                        value: 'Cód item',
                      },
                      {
                        key: 'desitem',
                        value: 'Descrição item',
                      },
                      {
                        key: 'codder',
                        value: 'Código derivação',
                      },
                      {
                        key: 'desder',
                        value: 'Descrição derivação',
                      },
                      {
                        key: 'qtd',
                        value: 'Quantidade',
                      },
                      {
                        key: 'datprv',
                        value: 'Data entrega',
                      },
                      {
                        key: 'valortotal',
                        value: 'Valor Total',
                      },
                      {
                        key: 'valorunitario',
                        value: 'Valor Unitário',
                      },
                      {
                        key: 'unidademedida',
                        value: 'Unidade de Medida',
                      },
                      {
                        key: 'codFinanceira',
                        value: 'Código Conta Financeira',
                      },
                      {
                        key: 'desFinanceira',
                        value: 'Descrição Conta Financeira',
                      },
                      {
                        key: 'codContabil',
                        value: 'Código Conta Contabil',
                      },
                      {
                        key: 'desContabil',
                        value: 'Descrição Conta Contabil',
                      },
                      {
                        key: 'codccu',
                        value: 'Centro de custos',
                      },
                      {
                        key: 'desccu',
                        value: 'Descrição centro de custos',
                      },
                    ]
                  }
                />
              </TabPanel>

              <TabPanel value={tab} index={1}>
                {
                  fields.filter(((item) => item.tipo === 'servico')).length === 0 && 
                  <Box mt={3}>
                    <Typography>Nenhum produto criado</Typography>
                  </Box>
                }
                <ItemsDrawer
                  fields={fields.filter(((item) => item.tipo === 'servico'))} 
                  fieldsItems={fieldsItems}
                  keyTitle='descricao'
                  keySubTitle=''
                  labelsFields={
                    [
                      {
                        key: 'coditem',
                        value: 'Cód item',
                      },
                      {
                        key: 'desitem',
                        value: 'Descrição item',
                      },
                      {
                        key: 'codder',
                        value: 'Código derivação',
                      },
                      {
                        key: 'desder',
                        value: 'Descrição derivação',
                      },
                      {
                        key: 'qtd',
                        value: 'Quantidade',
                      },
                      {
                        key: 'datprv',
                        value: 'Data entrega',
                      },
                      {
                        key: 'valortotal',
                        value: 'Valor Total',
                      },
                      {
                        key: 'valorunitario',
                        value: 'Valor Unitário',
                      },
                      {
                        key: 'unidademedida',
                        value: 'Unidade de Medida',
                      },
                      {
                        key: 'codFinanceira',
                        value: 'Código Conta Financeira',
                      },
                      {
                        key: 'desFinanceira',
                        value: 'Descrição Conta Financeira',
                      },
                      {
                        key: 'codContabil',
                        value: 'Código Conta Contabil',
                      },
                      {
                        key: 'desContabil',
                        value: 'Descrição Conta Contabil',
                      },
                      {
                        key: 'codccu',
                        value: 'Centro de custos',
                      },
                      {
                        key: 'desccu',
                        value: 'Descrição centro de custos',
                      },
                    ]
                  }
                />
              </TabPanel>

              <TabPanel value={tab} index={2}>
                {
                  parcelas.length === 0 && 
                  <Box mt={3}>
                    <Typography>Não tem parcelas especiais</Typography>
                  </Box>
                }
                <ItemsDrawer
                  fields={parcelas} 
                  fieldsItems={fieldsParcelas}
                  keyTitle='descricao'
                  keySubTitle=''
                  labelsFields={
                    [
                      {
                        key: 'vctpar',
                        value: 'Vencimento parcela',
                      },
                      {
                        key: 'seqpar',
                        value: 'Número parcela',
                      },
                      {
                        key: 'vlrpar',
                        value: 'Valor parcela',
                      },
                    ]
                  }
                />
              </TabPanel>
              <TabPanel value={tab} index={3}>
                <Grid container spacing={2} style={{ padding: 8, marginTop: 16, gap: 16 }}>
                  <Box mt={2} width="100%">
                    {(generalFields.find(f => f.id === 'arquivos')?.value?.arquivos || []).map((file: File, idx: number) => (
                      <Grid
                        key={idx}
                        container
                        alignItems="center"
                        spacing={1}
                        style={{ marginBottom: 8 }}
                      >
                        {/* Link clicável para visualizar */}
                        <Grid item xs>
                          <Typography
                            variant="body2"
                            component="span"
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => {
                              const url = URL.createObjectURL(file);
                              window.open(url, '_blank');
                              setTimeout(() => URL.revokeObjectURL(url), 1000);
                            }}
                          >
                            {file.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                    {(generalFields.find(f => f.id === 'arquivos')?.value?.arquivos || []).length === 0 && 
                      <Typography>
                        Nenhum arquivo inserido
                      </Typography>
                    }
                  </Box>
                </Grid>
              </TabPanel>
            </Grid>
          </Grid>
        </div>
        <div className={classes.drawerFooter}>
          <Button
            onClick={handleCloseDrawer}
            className={classes.backBackgroundColor}
          >
            Voltar
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

export default PurchaseOrderConsult;